export default __webpack_public_path__ + "static/media/EM0370.34I-22414_-15112_0.bdb449b0.jpg";